import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import Swal from "sweetalert2"; 
import { useNavigate } from "react-router-dom";
// Services
import OperationFileService from "../../../services/operationFileService";


function ModalAuthorizationsComments( {handleOpen, isOpen, title}) {

    const navigate = useNavigate();
    const [comments, setComments] = useState('');
    const doCloseButton = () => { handleOpen(false) }
   
    const doSaveButton = (id) => { 
        if(comments === '' && comments === null){
            try {
                const response = OperationFileService.putOperationAuthComments(id, {note: comments})
                handleOpen(false) 
                setComments('')
            } catch (error) {
                if(error.response.status !== 401){
                    Swal.fire({
                        title: 'Ooops?',
                        text: error.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        }
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Comentarios: {title} </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Comentarios</FormLabel>
                                <Textarea
                                    onChange={(event) => { setComments(event.target.value) }}
                                    value={comments}
                                    placeholder="Escriba aqui..."
                                    minRows={4}
                                    maxRows={4}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info mb-2 d-grid w-100" onClick={doSaveButton}>Guardar</button>            
                    <button type="button" className="btn btn-secondary mb-2 d-grid w-100" onClick={doCloseButton}>Cerrar</button>     
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalAuthorizationsComments;